import Box from "@mui/material/Box";
import { useAuthContext } from "../../hooks/Auth";
import { useJobContext } from "../../hooks/Jobs";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import UmmIACoin from "../../components/UmmIAChatAI/svg/UmmIACoin.svg";
import { Typography } from "@mui/material";

export default function CreditosNavBar() {
  const { user } = useAuthContext();

 
  const usados = user?.creditosUsados ?? 0;
  const disp = user?.creditosDisponibles ?? 0;
  
  const hideText = true;
  return (
    <>
     {/** Contenedor de Créditos */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              p: 1,
              borderRadius: 2,
            }}
          >
            {/* Medidor circular con icono dentro */}
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Gauge
                value={user?.creditosUsados}
                valueMax={usados + disp}
                startAngle={-360}
                endAngle={360}
                sx={{
                  width: { xs: 100, sm: 100, md: 45 },
                  height: { xs: 100, sm: 100, md: 45 },
                 [`& .${gaugeClasses.valueText}`]: hideText
                ? { display: 'none' }
                : { fontSize: 11, fontFamily: 'Montserrat' },
                  [`& .${gaugeClasses.valueArc}`]: { fill: "#336B87" },
                  [`& .${gaugeClasses.referenceArc}`]: { fill: "#90AFC5" },
                }}
              // text={({ value, valueMax }) => `${value} / ${valueMax} créditos`}
              />
              <Box
                sx={{
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={UmmIACoin} alt="Créditos usados" width={15} height={15} />
              </Box>
            </Box>

            {/* Textos */}
            <Box sx={{ ml: -1 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: "rgba(0, 0, 0, 0.6)",
                  fontFamily: "Montserrat",
                  fontSize: "11px",
                }}
              >
                Has usado:
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "rgba(0, 0, 0, 0.6)",
                  fontFamily: "Montserrat",
                  fontSize: "13px",
                  mt: -0.5
                }}
              >
                {user?.creditosUsados} / {user?.creditosDisponibles} créditos
              </Typography>
            </Box>
          </Box>
      
    </>
  );
}
